import * as actionTypes from './types';

export const paymentsOffersStart = () => ({
    type: actionTypes.PAYMENTS_OFFERS_START,
});

export const paymentsOffersSuccess = (data) => ({
    type: actionTypes.PAYMENTS_OFFERS_SUCCESS,
    data,
});

export const paymentsOffersFail = (error) => ({
    type: actionTypes.PAYMENTS_OFFERS_FAIL,
    error,
});

/**
 * @typedef GetPaymentsOffersPayload
 * @type {object}
 * @property {number} [limit]
 * @property {number} [offset]
 * @property {boolean} [incrementViewCount] - true only from the Working Capital page
 *   view, so the DB counts it as a view; omitted by the dashboard banner fetch.
 *
 * @param {GetPaymentsOffersPayload} [data]
 */
export const getPaymentsOffers = (data) => ({
    type: actionTypes.GET_PAYMENTS_OFFERS,
    data,
});
